import {callAppAPI} from "./AppApiClient";
import {DictionnaireApi} from "./DictionnaireApi";
import {Document} from "src/domain/Document";
import {callAppAPIByte} from "src/app/api/AppApiClientByte";
import {saveAs} from "file-saver";


export const getDocuments = async () : Promise<Document[]> => {
    return callAppAPI<Document[]>({
        method: "GET",
        url: DictionnaireApi.getDocuments.getUrl(),
    })
        .then(result => {
            return result;
        });
};

export const downloadDocument = (id: number) => {
    const url = DictionnaireApi.downloadDocument.getUrl(id);
    return callAppAPIByte<any>({
        method: "GET",
        url: url,
    }).then((result) => {
        const fileName = result.headers["content-disposition"].split('filename="')[1].slice(0, -1);
        saveAs(result.data, fileName);
    });
};
